import { gql } from '@apollo/client';

export const SIGNUP = gql`
  mutation createUserContent($name: String!, $email: String!, $password: String!) {
    createUserContent(input: { 
      name: $name
      email: $email
      password: $password
      role:"WRITER"
    }) {
      id
    }
  }
`;
